export default function (num) {
  const n = Number(num)
  return Math.round(n)
}
